import { render, staticRenderFns } from "./ViewActivityLabourerWorkplacePage.vue?vue&type=template&id=09bfe8b7&scoped=true&"
import script from "./ViewActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./ViewActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewActivityLabourerWorkplacePage.vue?vue&type=style&index=0&id=09bfe8b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bfe8b7",
  null
  
)

export default component.exports